import React from 'react'

function Dashboard() {
  return (
    <>
    <div className="h-10 m-0 p-0 bg-slate-500 opacity-30" style={{borderRadius:'4px'}}>
          <input type="text" className=" m-2" style={{borderRadius: '4px'}} placeholder="Search"/>
        </div>
    <div>Dashboard</div>
    </>
  )
}

export default Dashboard